// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".virtual-list{overflow-y:auto;position:relative;-webkit-overflow-scrolling:touch}.virtual-list *{box-sizing:border-box}.scroll-list{position:absolute;top:0;left:0;width:100%}.waterfall-list{display:flex;justify-content:space-between}.left-wrap,.right-wrap{width:50%}.left-item,.right-item{overflow:hidden}", ""]);
// Exports
module.exports = exports;
